import React, { useState, useEffect } from "react";

import Login from "../pages/Login";

//import React, { useState } from "react";
import { FaChevronDown } from "react-icons/fa";


import "./Navbar.css";
import { FaSearch, FaRegStar, FaBell, FaWhatsapp } from "react-icons/fa";
import logo from "./logo.png";
// import { NavLink, Link } from "react-router-dom";
import { NavLink, Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
// import { useNavigate } from "react-router-dom";

import { useRef } from "react";

import { useContext } from "react";
import { NotificationContext } from "../context/NotificationContext";


import axios from "axios";
// import { Link } from "react-router-dom";



const BASE_URL = process.env.REACT_APP_BASE_URL;


const Navbar = () => {


   const [categories, setCategories] = useState([]);
  const [openProductsDropdown, setOpenProductsDropdown] = useState(false);

  const fetchCategories = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/api/categories`);
      setCategories(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchCategories();

    // 🔥 auto update when new category added
    const handleUpdate = () => fetchCategories();
    window.addEventListener("categoryAdded", handleUpdate);

    return () => {
      window.removeEventListener("categoryAdded", handleUpdate);
    };
  }, []);




const { notifications } = useContext(NotificationContext);

  // const { notifications, markAllRead } = useContext(NotificationContext);
  // const unreadCount = notifications.filter(n => !n.read).length;



const [openNotifications, setOpenNotifications] = useState(false);






  const [openSearch, setOpenSearch] = useState(false);
  const [mobileMenu, setMobileMenu] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(false); // mobile dropdown toggle
  const[openMenu,setOpenMenu]=useState(false);
  const [openTeamDropdown, setOpenTeamDropdown] = useState(false);
const [openCompanyDropdown, setOpenCompanyDropdown] = useState(false);
const [openScienceDropdown, setOpenScienceDropdown] = useState(false);

  const [openResearchDropdown, setOpenResearchDropdown] = useState(false);


  // 🔹 Add this for Products dropdown
// const [openProductsDropdown, setOpenProductsDropdown] = useState(false);


  
  //const { user, logout } = useAuth();

const { user, role, logout } = useAuth();

  const navigate = useNavigate();

  const [showLogin,setShowLogin]=useState(false);





  const [searchTerm, setSearchTerm] = useState("");

// 1️⃣ static pages
const staticPages = [
  { name: "Ayurvedic Science", path: "/ayurveda"},
  { name: "Ethical Ingredient Sourcing", path: "/ethical-ingredient-sourcing" },
  { name: "Sustainability Responsibility", path: "/sustainability-responsibility" },
  { name: "Research & Insights", path: "/research" },
  { name: "Nanotechnology", path: "/technology/nanotechnology" },
  { name: "Plasma Technology", path: "/technology/plasma-technology" },
  { name: "Plant Stem Cell Technology", path: "/technology/plant-stem-cell" },
  { name: "Enzymatic Technology", path: "/technology/enzymatic-technology" },
  { name: "Microbiome Technology", path: "/technology/microbiome-technology" },
  { name: "EmolliHydra Technology", path: "/technology/emollihydra-technology" },
  { name: "Exosome Technology", path: "/technology/exosome-technology" },
  { name: "About Us", path: "/about" },
  { name: "Contact", path: "/contact" }
];

// 2️⃣ dynamic categories
const dynamicSearchData = categories.map((cat) => ({
  name: cat.name,
  path: `/category/${cat.name.toLowerCase().replace(/\s+/g, "-")}`,
}));

// 3️⃣ combine
const searchData = [...dynamicSearchData, ...staticPages];

// 4️⃣ filter (LAST me hona chahiye)
const filteredResults = searchTerm
  ? searchData
      .filter((item) =>
        item.name.toLowerCase().includes(searchTerm.toLowerCase())
      )
      .slice(0, 6)
  : [];


// useEffect(() => {
//   const handleClickOutside = () => {
//     setOpenDropdown(false);
//     setOpenResearchDropdown(false);
//     setOpenScienceDropdown(false);
//     setOpenCompanyDropdown(false);
//   };

const menuRef = useRef();

useEffect(() => {
  const handleClickOutside = (e) => {
    if (menuRef.current && !menuRef.current.contains(e.target)) {
      setMobileMenu(false);
      setOpenDropdown(false);
      setOpenResearchDropdown(false);
      setOpenScienceDropdown(false);
      setOpenCompanyDropdown(false);
      setOpenProductsDropdown(false);
      setOpenMenu(false);

       setOpenNotifications(false);
      
    }
  };

  document.addEventListener("mousedown", handleClickOutside);

  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, []);
// const handleClickOutside = (e) => {
//   if (!e.target.closest(".dropdown")) {
//     setOpenDropdown(false);
//     setOpenResearchDropdown(false);
//     setOpenScienceDropdown(false);
//     setOpenCompanyDropdown(false);
//     setOpenProductsDropdown(false);
//     setOpenMenu(false); // 🔥 IMPORTANT (Admin dropdown close)  
//   }
// };


// useEffect(() => {
//   const handleClickOutside = () => {
//     setOpenDropdown(false);
//     setOpenResearchDropdown(false);
//     setOpenScienceDropdown(false);
//     setOpenCompanyDropdown(false);
//    setOpenProductsDropdown(false); // 🔥 ADD THIS  
//   };

//   document.addEventListener("click", handleClickOutside);

  // return () => {
//     document.removeEventListener("click", handleClickOutside);
//   };
// }, []);


// useEffect(() => {
//   document.addEventListener("click", handleClickOutside);
//   return () => {
//     document.removeEventListener("click", handleClickOutside);
//   };
// }, []);



  return (

    <>
    <div className="navbar">
      <div className="nav-row">
        {/* HAMBURGER MOBILE */}
        <div
          className="hamburger"
          onClick={() => setMobileMenu(!mobileMenu)}
        >
          ☰
        </div>

        {/* LEFT - LOGO */}
        <div className="nav-left">
          <img src={logo} alt="logo" />
        </div>

        {/* CENTER - SEARCH */}
      <div className={`search-container ${openSearch ? "active" : ""}`}>
  <FaSearch
    className="search-icon"
    onClick={() => setOpenSearch(!openSearch)}
  />

  <input
    type="text"
    placeholder="Search products..."
    value={searchTerm}
    onChange={(e) => setSearchTerm(e.target.value)}
  />


  {searchTerm && (
  <div className="search-results">
    {filteredResults.map((item, index) => (
      <div
        key={index}
        className="search-item"
        onClick={() => {
          navigate(item.path);
          setSearchTerm("");
          setMobileMenu(false); // 🔥 ADD THIS


          setOpenSearch(false);  // 🔥 ADD THIS
        }}
      >
        {item.name}
      </div>
    ))}
  </div>
)}

{searchTerm && filteredResults.length === 0 && (
  <div className="search-item">No results found</div>
)}
</div>
 
                  
               


        {/* RIGHT - ICONS + LOGIN */}
        <div className="nav-right">
          <FaWhatsapp
  className="whatsapp-icon"
  onClick={() => {
    window.open("https://wa.me/919949896254", "_blank");
  }}
/>
          {/* <FaBell /> */}

<div className="bell-container">

  <FaBell 
    onClick={() => {
      console.log("bell clicked"); // ✅ DEBUG
      setOpenNotifications(!openNotifications);
    }}   />

  {notifications.length > 0 && (
    <span className="notification-badge">
      {notifications.length}
    </span>
  )}

  {openNotifications && (
    <div className="notification-dropdown">
      {notifications.length === 0 ? (
        <p>No Notifications</p>
      ) : (
        notifications.map((n, index) => (
          <div key={index} className="notification-item">
            <h4>{n.name}</h4>
            <p>{n.category}</p>
            <small>{n.description}</small>
          </div>
        ))
      )}
    </div>
  )}

</div>




          {/* <FaUser 
          //  className="user-icon"
          //  onClick={() => navigate("/register")}
          /> */}

          {/*{user ? (
            <>
              <span className="username">Hi, {user.name}</span>
              <button className="login-btn" onClick={logout}
              >
                Logout
              </button>

            </>
          ) : (
            <button className="login-btn" onClick={() => navigate("/login")}>
              Login
            </button>
          )}
*/}

 {/* 👇 THIS SHOULD BE OUTSIDE
    {showLogin && (
      <Login closeModal={() => setShowLogin(false)} />
    )} */}

{user ? (
  <>
    <button className="login-btn" onClick={logout}>
      Logout
    </button>
  </>
) : (
  <>
    <button
      className="login-btn"
onClick={() => {
  setMobileMenu(false);
  setShowLogin(true);
}}


//     onClick={() => {
//   setShowLogin(true);
//   setMobileMenu(false); // 🔥 ADD THIS
// }}
    >
      Login
    </button>

    {showLogin && (
      <Login closeModal={() => setShowLogin(false)} />
    )}
  </>
)}


          
        </div>
      </div>

      {/* ===== MENU BAR ===== */}
      {/* <div className={`menubar ${mobileMenu ? "active" : ""}`}> */}

<div
  className={`menubar ${mobileMenu ? "active" : ""}`}
  ref={menuRef}
>

        
        <div className="menu-links">



    {/* ✅ ADD HERE */}
    <div className="mobile-top-title">
      ManuX NanoBioCeuticals
    </div>


          {/* MOBILE ICONS */}
<div className="mobile-icons">

            <FaWhatsapp
  className="whatsapp-icon"
  onClick={() => {
    window.open("https://wa.me/919949896254", "_blank");
  }}
/>

  <FaBell />

  {/* <FaUser
    className="user-icon"
    onClick={() => navigate("/register")}
  /> */}

  {/* <FaUser 
  // className="user-icon"
  // onClick={() => {
  //   navigate("/register");
  //   setMobileMenu(false); // 🔥 ADD THIS
  // }}
/> */}

  {user ? (
    <button className="login-btn" onClick={logout}>
      Logout
    </button>
  ) : (
    <button
      className="login-btn"
//       onClick={() => {
//   navigate("/login");   // 🔥 page open hoga
//   setMobileMenu(false);
// }}
onClick={() => {
  setShowLogin(true);
  setMobileMenu(false); // 🔥 ADD THIS
}}    
>
      Login
    </button>
  )}

</div>


          <NavLink to="/" onClick={() => setMobileMenu(false)}>
             Home
          </NavLink>
       {/*}   {mobileMenu && (
  <div
    className="overlay2"
    onClick={() => setMobileMenu(false)}
  ></div>
)}*/}

          {/* TECHNOLOGY DROPDOWN */}
          <div
  className="dropdown"
  onClick={(e) => e.stopPropagation()}
>
  <span
    className="nav-link"
    onClick={() => {
       setOpenDropdown(!openDropdown);

  // 🔥 CLOSE ALL OTHER DROPDOWNS
      setOpenResearchDropdown(false);
      setOpenScienceDropdown(false);
      setOpenCompanyDropdown(false);
      setOpenProductsDropdown(false);
      setOpenMenu(false); // 🔥 IMPORTANT (Admin dropdown close)  
   
      
    }}
  >
    Technology <FaChevronDown className="dropdown-icon" />
  </span>

  <div className={`dropdown-menu ${openDropdown ? "show-dropdown" : ""}`}>
    
    <Link to="/technology/nanotechnology"   onClick={() => {
    setMobileMenu(false);   // 🔥 ADD THIS
    setOpenDropdown(false);
  }}>
      Nanotechnology
    </Link>

    <Link to="/technology/plasma-technology"   onClick={() => {
    setMobileMenu(false);   // 🔥 ADD THIS
    setOpenDropdown(false);
  }}>
      Plasma Technology
    </Link>

    <Link to="/technology/plant-stem-cell"   onClick={() => {
    setMobileMenu(false);   // 🔥 ADD THIS
    setOpenDropdown(false);
  }}>
      Plant Stem Cell Technology
    </Link>

    <Link to="/technology/Enzymatic-Technology"   onClick={() => {
    setMobileMenu(false);   // 🔥 ADD THIS
    setOpenDropdown(false);
  }}>
      Enzymatic Technology
    </Link>

    <Link to="/technology/microbiome-technology"  onClick={() => {
    setMobileMenu(false);   // 🔥 ADD THIS
    setOpenDropdown(false);
  }}>
      Microbiome Technology
    </Link>

    <Link to="/technology/emollihydra-technology"   onClick={() => {
    setMobileMenu(false);   // 🔥 ADD THIS
    setOpenDropdown(false);
  }}>
      EmolliHydra™ Technology
    </Link>

    <Link to="/technology/exosome-technology"   onClick={() => {
    setMobileMenu(false);   // 🔥 ADD THIS
    setOpenDropdown(false);
  }}>
      Exosome Technology
    </Link>

  </div>
</div>





<div className="dropdown"
     onClick={(e) => e.stopPropagation()}>

  <span
    className="nav-link"
    onClick={() => {
      setOpenProductsDropdown(!openProductsDropdown);

      // 🔥 CLOSE OTHERS
      setOpenDropdown(false);
      setOpenResearchDropdown(false);
      setOpenScienceDropdown(false);
      setOpenCompanyDropdown(false);
      //setOpenProductsDropdown(false); 
      setOpenMenu(false); // 🔥 IMPORTANT (Admin dropdown close)   
    }}
  >
    Products <FaChevronDown className="dropdown-icon" />
  </span>


  <div className={`dropdown-menu ${openProductsDropdown ? "show-dropdown" : ""}`}>
  
  {categories.map((cat) => (
    <Link
      key={cat._id}
      to={`/category/${cat.name.toLowerCase().replace(/\s+/g, "-")}`}
      onClick={() => {
        setOpenProductsDropdown(false);
      }}
    >
      {cat.name.replace(/"/g, "")}
    </Link>
  ))}

</div>

  {/* <div className={`dropdown-menu ${openProductsDropdown ? "show-dropdown" : ""}`}>

    <Link to="/skin-care" onClick={() => {
      setMobileMenu(false);
      setOpenProductsDropdown(false);
    }}>
      Skin Care
    </Link>

    <Link to="/hair-care" onClick={() => {
      setMobileMenu(false);
      setOpenProductsDropdown(false);
    }}>
      Hair Care
    </Link>

    <Link to="/baby-care" onClick={() => {
      setMobileMenu(false);
      setOpenProductsDropdown(false);
    }}>
      Baby Care
    </Link>

    <Link to="/pet-care" onClick={() => {
      setMobileMenu(false);
      setOpenProductsDropdown(false);
    }}>
      Pet Care
    </Link>

    <Link to="/mens-care" onClick={() => {
      setMobileMenu(false);
      setOpenProductsDropdown(false);
    }}>
      Men's Care
    </Link>

   <Link to="/pregnancy-care" onClick={() => {
      setMobileMenu(false);
      setOpenProductsDropdown(false);
    }}>
      Pregnancy Care
    </Link>

    <Link to="/teenager-care" onClick={() => {
      setMobileMenu(false);
      setOpenProductsDropdown(false);
    }}>
     Teenager Care
    </Link>

     <Link to="/longevity" onClick={() => {
      setMobileMenu(false);
      setOpenProductsDropdown(false);
    }}>
     Longevity
    </Link>

    <Link to="/nutraceuticals" onClick={() => {
      setMobileMenu(false);
      setOpenProductsDropdown(false);
    }}>
      Nutraceuticals
    </Link> 

        <Link to="/digital-defense" onClick={() => {
      setMobileMenu(false);
      setOpenProductsDropdown(false);
    }}>
      Digital Defense
    </Link>
        <Link to="/fitness" onClick={() => {
      setMobileMenu(false);
      setOpenProductsDropdown(false);
    }}>
      Fitness
    </Link>


       <Link to="/color-cosmetics" onClick={() => {
      setMobileMenu(false);
      setOpenProductsDropdown(false);
    }}>
   Color Cosmetics
    </Link>

  </div>*/}
</div> 



        <div
  className="dropdown"
  onClick={(e) => e.stopPropagation()}
>
  <span
    className="nav-link"
onClick={() => {
  setOpenResearchDropdown(!openResearchDropdown);

  // 🔥 CLOSE OTHERS
  setOpenDropdown(false);
  setOpenScienceDropdown(false);
  setOpenCompanyDropdown(false);
  setOpenProductsDropdown(false);  
  setOpenMenu(false); // 🔥 IMPORTANT (Admin dropdown close)  
}}
  >
    Research <FaChevronDown className="dropdown-icon" />
  </span>

  <div
    className={`dropdown-menu ${
      openResearchDropdown ? "show-dropdown" : ""
    }`}
  >

    <Link
      to="/research"
      onClick={() => {
        setMobileMenu(false);
        setOpenResearchDropdown(false);
      }}
    >
      Research
    </Link>

    <Link
      to="/sustainability-responsibility"
      onClick={() => {
        setMobileMenu(false);
        setOpenResearchDropdown(false);
      }}
    >
      Sustainability
    </Link>

    <Link
  to="/ethical-ingredient-sourcing"
  onClick={() => {
    setMobileMenu(false);
    setOpenResearchDropdown(false);
  }}
>
  Ingredient
</Link>

  </div>
</div>
         {/*} <NavLink to="/ingredients" onClick={() => setMobileMenu(false)}>
            Ingredients
          </NavLink>*/}
          {/* <NavLink to="/Ayurveda"onClick={() => setMobileMenu(false)} >
            Ayurvedic Science
          </NavLink> */}
          {/* <NavLink to="/ethical-ingredient-sourcing" onClick={() => setMobileMenu(false)}>
             Ingredient 
          </NavLink> */}
           {/* <NavLink to="/sustainability-responsibility" onClick={() => setMobileMenu(false)}>
           Sustainability 
          </NavLink> */}
          {/* <NavLink to="/quality-safety-compliance" onClick={() => setMobileMenu(false)}>
           Safety & Compliance
          </NavLink> */}



       <div className="dropdown Sci-dropdown"
  onClick={(e) => e.stopPropagation()}
>
  <span
    className="nav-link"
    onClick={() => {
      setOpenScienceDropdown(!openScienceDropdown);
      setOpenCompanyDropdown(false); // 👈 close other
      setOpenResearchDropdown(false);
      setOpenDropdown(false);
      setOpenProductsDropdown(false);  
      setOpenMenu(false); // 🔥 IMPORTANT (Admin dropdown close)  
    }}
  >
    Science <FaChevronDown className="dropdown-icon" />
  </span>

  <div className={`dropdown-menu ${openScienceDropdown ? "show-dropdown" : ""}`}>
    
    {/* <Link to="/Ayurveda"   onClick={() => {
    setMobileMenu(false);   // 🔥 ADD THIS
    setOpenDropdown(false);
  }}>
      Ayurvedic Science
    </Link> */}

    <Link to="/quality-safety-compliance"   onClick={() => {
    setMobileMenu(false);   // 🔥 ADD THIS
        setOpenScienceDropdown(false); // ✅ THIS IS THE MAIN FIX
  }}>
      Safety & Compliance
    </Link>

  </div>
</div>





<div className="dropdown team-dropdown"
  onClick={(e) => e.stopPropagation()}
>
  <span
    className="nav-link"
    onClick={() => {
      setOpenCompanyDropdown(!openCompanyDropdown);
      setOpenScienceDropdown(false); // 👈 close other
      setOpenResearchDropdown(false);
      setOpenDropdown(false);
     setOpenProductsDropdown(false); 
     setOpenMenu(false); // 🔥 IMPORTANT (Admin dropdown close)  
    }}
  >
    Company <FaChevronDown className="dropdown-icon" />
  </span>

  <div className={`dropdown-menu ${openCompanyDropdown ? "show-dropdown" : ""}`}>
    
 <Link to="/about"   onClick={() => {
    setMobileMenu(false);   // 🔥 ADD THIS
    setOpenCompanyDropdown(false); // ✅ THIS IS MAIN FIX
  }}>
      About Us
    </Link>

       <Link to="/why-manux"   onClick={() => {
    setMobileMenu(false);   // 🔥 ADD THIS
   setOpenCompanyDropdown(false); // ✅ THIS IS MAIN FIX
  }}>
   Why ManuX
    </Link>

    <Link to="/OurTeam"   onClick={() => {
    setMobileMenu(false);   // 🔥 ADD THIS
    setOpenCompanyDropdown(false); // ✅ THIS IS MAIN FIX
  }}>
      Team Members
    </Link>


     <Link to="/collaborations"   onClick={() => {
    setMobileMenu(false);   // 🔥 ADD THIS
    setOpenCompanyDropdown(false); // ✅ THIS IS MAIN FIX
  }}>
    Collaborations
    </Link>


   

  </div>
</div>


          <NavLink to="/contact" onClick={() => setMobileMenu(false)}>
            Contact
          </NavLink>
              

              {/* ADMIN DASHBOARD */}

          {/* {role === "admin" && (
                  <NavLink to="/admin/dashboard" onClick={() => setMobileMenu(false)} >
                       <span>Admin Dashboard</span>
                  </NavLink>
                    )}

                    </div> */}


                    {role === "admin" && (
//   <div
//     className="dropdown admin-dropdown"
//     onClick={(e) => e.stopPropagation()}
//   >
//     <span
//       className="nav-link"
//       onClick={() => {
//         setOpenMenu(!openMenu);

//         // close others
//         setOpenDropdown(false);
//         setOpenResearchDropdown(false);
//         setOpenScienceDropdown(false);
//         setOpenCompanyDropdown(false);
//         setOpenProductsDropdown(false);
//       }}
//     >
//       Admin Dashboard <FaChevronDown className="dropdown-icon" />
//     </span>

//     <div className={`dropdown-menu ${openMenu ? "show-dropdown" : ""}`}>

//       <Link to="/admin/dashboard/product-form" onClick={() => {
//         setMobileMenu(false);
//         setOpenMenu(false);
//       }}>
//         Products Form
//       </Link>

//       <Link to="/admin/dashboard/product-list" onClick={() => {
//         setMobileMenu(false);
//         setOpenMenu(false);
//       }}>
//         Products List
//       </Link>

//       <Link to="/admin/dashboard/Contact-list" onClick={() => {
//         setMobileMenu(false);
//         setOpenMenu(false);
//       }}>
//         Contact List
//       </Link>

//     </div>
//   </div>
// )}

<div className="dropdown admin-dropdown">

{/* <div ref={dropdownRef} className="dropdown admin-dropdown"> */}
  
  <span
    className="nav-link"
    onClick={() => {
      setOpenMenu(!openMenu);

      setOpenDropdown(false);
      setOpenResearchDropdown(false);
      setOpenScienceDropdown(false);
      setOpenCompanyDropdown(false);
      setOpenProductsDropdown(false);
    }}
  >
    Admin Dashboard <FaChevronDown />
  </span>

  <div className={`dropdown-menu ${openMenu ? "show-dropdown" : ""}`}>

    <Link to="/admin/dashboard/product-form" onClick={() => {
      setMobileMenu(false);
      setOpenMenu(false);
    }}>
      Products Form
    </Link>

    <Link to="/admin/dashboard/product-list" onClick={() => {
      setMobileMenu(false);
      setOpenMenu(false);
    }}>
      Products List
    </Link>

    <Link to="/admin/dashboard/Contact-list" onClick={() => {
      setMobileMenu(false);
      setOpenMenu(false);
    }}>
      Contact List
    </Link>


        <Link to="/admin/dashboard/categories" onClick={() => {
      setMobileMenu(false);
      setOpenMenu(false);
    }}>
      Categories
    </Link>

        {/* <Link to="/admin/dashboard/category-list" onClick={() => {
      setMobileMenu(false);
      setOpenMenu(false);
    }}>
    Category List
    </Link> */}


  </div>
</div>
  )}

          {/*} <div className="dropdown">
            <span
              className="nav-link"
              onClick={() => setOpenDropdown(!openDropdown)}
            >
              AdminDashboard
            </span>

            <div
              className={`dropdown-menu ${
                openDropdown ? "show-dropdown" : ""
              }`}
            >
             <Link

    to="/AdminDashboard/Productsform" onClick={() => {
      setMobileMenu(false);
      setOpenMenu(false);
    }}
  >
Product form  </Link>

  <Link
    to="/AdminDashboard/ProductList"
    onClick={() => {
      setMobileMenu(false);
      setOpenMenu(false);
    }}
  >
Product List  </Link>

 <Link
    to="/AdminDashboard/UserList"
    onClick={() => {
      setMobileMenu(false);
      setOpenMenu(false);
    }}
  >
    Plant Stem Cell Technology
  </Link>


            </div>

          </div>          
*/}
            </div>  {/* menu-links END */}
      </div>  {/* menubar END */}
    </div> 

      {showLogin && (
      <Login closeModal={() => setShowLogin(false)} />
    )}
  </>
            

  );
};

export default Navbar;